import { type StoredAskPunttNotificationPrefs } from "@mg/schemas/src/commons/askPunttNotificationPrefs";

export function shouldShowAskV2ReviewEmailNotificationCta(input: {
  chatId: string | null | undefined;
  emailReviewComplete: boolean | undefined;
  dismissedForChat: boolean;
  profileLoaded: boolean;
  /** True while a review is in flight (started, not yet finished). */
  reviewInProgress: boolean;
}): boolean {
  if (!input.profileLoaded || !input.chatId) return false;
  if (input.emailReviewComplete === true) return false;
  if (input.dismissedForChat) return false;
  if (!input.reviewInProgress) return false;
  return true;
}

/**
 * Turn the review-complete email on, touching nothing else.
 *
 * why-not parsing `stored` through `askPunttNotificationPrefsSchema` first:
 * that fills every absent toggle with its schema default, and the profile PUT
 * replaces the stored object wholesale — so enabling the email also wrote a
 * deliberate-looking value for five toggles the person has never been asked
 * about. Only the key this CTA is about may be added; the stored keys ride
 * along unchanged because the server replaces rather than merges.
 */
export function mergeReviewEmailNotificationPrefEnabled(
  stored: StoredAskPunttNotificationPrefs | null | undefined,
): StoredAskPunttNotificationPrefs {
  return { ...(stored ?? {}), emailReviewComplete: true };
}
